import { useChatStore } from "@/store/useChatStore";
import Image from "@/components/Image";
import { useEffect, useState, useRef } from "react";
import { getQuestById } from "@/lib/questHelper";
import useAuthStore from "@/store/useAuthStore";

export const UserAvatar = () => {
  return (
    <div className="w-8 h-8 rounded-full bg-gradient-to-b from-[#BA31FF] to-[#FFB482] flex items-center justify-center">

    </div>
  )
}

export const AssistantAvatar = () => {
  const { quest } = useChatStore();
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);

  useEffect(() => {
    // If avatar URL is already available in quest data, use it
    if (quest?.instructor_profile?.avatar_url) {
      setAvatarUrl(quest.instructor_profile.avatar_url);
    }
  }, [quest]);

  if (!avatarUrl || avatarUrl.trim() === '') {
    return null;
  }

  return (
    <div className="w-8 h-8 rounded-full flex items-center justify-center">
      {avatarUrl && avatarUrl.trim() !== '' && (
        <Image
          src={avatarUrl}
          alt="Assistant Avatar"
          className="rounded-full"
          objectFit="contain"
          width={32}
          height={32}
          optimizedWidth={80}
        />
      )}
    </div>
  )
}

export const StandardAvatar = () => {
  const { quest } = useChatStore();
  const [fullBodyUrl, setFullBodyUrl] = useState<string | null>(null);

  useEffect(() => {
    const instructorProfile = quest?.instructor_profile as any;
    if (instructorProfile?.full_body_url) {
      setFullBodyUrl(instructorProfile.full_body_url);
    }
  }, [quest]);

  if (!fullBodyUrl || fullBodyUrl.trim() === '') {
    return null;
  }

  return (
    <Image
      src={fullBodyUrl}
      alt="Instructor Avatar"
      width={150}
      height={150}
      className="w-full h-full object-contain"
    />
  )
}

export const LetterAvatar = ({ backgroundColor = '#42C52D', name }: { backgroundColor?: string; name?: string }) => {
  const { user, profile } = useAuthStore();

  // 获取用户显示名称
  const getUserDisplayName = () => {
    if (name) {
      return name;
    }
    if (profile?.onboard_data?.profile?.name) {
      return profile.onboard_data.profile.name;
    }
    if (profile?.onboard_data?.profile?.firstName) {
      return profile.onboard_data.profile.firstName;
    }
    if (profile?.nickname) {
      return profile.nickname;
    }
    if (user?.user_metadata?.nickname) {
      return user.user_metadata.nickname;
    }
    if (user?.email) {
      return user.email.split('@')[0];
    }
    return 'User';
  };

  // 获取头像字母
  const getAvatarInitial = () => {
    const displayName = getUserDisplayName();
    return displayName.charAt(0).toUpperCase();
  };

  return (
    <div
      className={`flex items-center justify-center focus:outline-none relative`}
    >
      {/* 圣诞节活动 */}
      <div className={`display-text-bold h-[44px] w-[44px] rounded-full flex items-center justify-center text-white`} style={{ backgroundColor: backgroundColor }}>
        {getAvatarInitial()}
      </div>
    </div>
  )
}